<template>
  <div id="index">
    <template v-if="!isShow">
      <div class="tenant_title">请选择商户
        <a class="back_login" href="javascript:;" @click="stop">
          <img src="../image/tuichu.png" />
          <span>退出</span>
        </a>
      </div>
      <div class="tenant" v-bind:class="{ select: item.id==selectTenant}" v-for="item in tenantList" @click="bindPhone(item.id,item.name)">
        <span>{{item.name}}</span>
        <i class="el-icon-caret-right"></i>
      </div>
    </template>
    <SMS @back_sumbit="backSumbit" v-else></SMS>
  </div>
</template>
<script>
import { localToken } from "@/libs/util";
import { MessageBox } from "element-ui";
import requestImg from "@/assets/backhome.png";
import appApi from "@/api/api-app";
import SMS from "./sms.vue";
export default {
  name: "index",
  components: { SMS },
  data() {
    return {
      tenantList: [],
      requestImg,
      selectTenant: null,
      isBind: 0,
      openId: null,
      isShow: false,
    };
  },
  methods: {
    stop() {
      let that = this;
      const h = that.$createElement;
      MessageBox({
        message: h("div", null, [
          h("i", {
            class: "el-icon-warning message-login-title",
          }),
          h("span", { class: "message-login-txt" }, " 提示"),
          h("p", { class: "message-login-content" }, "您确认退出该登录？ "),
        ]),
        showCancelButton: true,
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        beforeClose: (action, instance, done) => {
          if (action === "confirm") {
            localToken.clearLocal();
            that.$router.push({
              path: "/login",
            });
            clearInterval(that.timer);
            that.timer = null;
            done();
          } else {
            done();
          }
        },
      });
    },
    backSumbit(value) {
      this.isShow = value;
    },
    bindPhone(id, name) {
      let that = this;
      localToken.setTenantname(name || "");
      appApi.setTenantSwitchById(id).then(
        (res) => {
          if (res) {
            localToken.setTenant(id);
            if (that.isBind == 0) {
              that.isShow = true;
              // that.$router.replace({ path: "/sms" });
            } else {
              let data2 = {
                openId: that.openId,
                tenantId: that.selectTenant,
              };
              appApi.getTokenByOpenId(data2).then(
                (res) => {
                  that.getApplicationConfiguration().then((res) => {
                    that.$router.push({
                      path: "/main",
                    });
                  });
                },
                (err) => {}
              );
            }
          }
        },
        (err) => {}
      );
    },
    getApplicationConfiguration() {
      return new Promise((resolve, reject) => {
        appApi
          .getApplicationConfiguration()
          .then((res) => {
            resolve(res);
          })
          .catch((err) => {
            reject(err);
          });
      });
    },
    init() {
      let that = this;
      let query = this.$route.query;
      if (query.isBind) localToken.setIsBind(query.isBind);
      if (query.openId) localToken.setOpenId(query.openId);
      if (query.tenantId) localToken.setTenantIds(query.tenantId);
      if (query.tenantName) localToken.setTenantNames(query.tenantName);

      that.isBind = localToken.getIsBind();
      that.openId = localToken.getOpenId();
      let tenantIds = localToken.getTenantIds();
      let tenantNames = localToken.getTenantNames();
      let tenantIdArr = tenantIds.split(",");
      let tenantNameArr = tenantNames.split(",");
      that.tenantList = tenantIdArr.map((item, index) => {
        return {
          id: item,
          name: tenantNameArr[index] || "暂无名称",
        };
      });
      that.selectTenant =
        that.tenantList.length == 0 ? null : that.tenantList[0].id;
    },
  },
  mounted() {
    this.init();
  },
};
</script>
<style lang="less">
#index {
  display: flex;
  flex-direction: column;
  > .tenant_title {
    letter-spacing: 1px;
    color: #fff;
    font-weight: bold;
    font-size: 20px;
    background: radial-gradient(
      circle farthest-corner at 55% 55%,
      #509eef,
      #2577ec
    );
    margin-bottom: 30px;
    position: relative;
    > .back_login {
      right: 20px;
      top: 0;
      display: flex;
      align-content: center;
      align-items: center;
      position: absolute;
      line-height: 67px;
      outline: none;
      color: #fff;
      text-decoration: none;
      > span {
        outline: none !important;
        color: #fff !important;
        text-decoration: none !important;
        font-size: 16px !important;
        font-weight: normal !important;
      }
    }
  }

  > .tenant_title,
  > .sms_title {
    padding: 20px;
  }
  > .tenant {
    cursor: pointer;
    padding: 12px;
    width: 200px;
    margin: auto;
    color: #fff;
    background-color: #4b91f6;
    border: 1px solid #fff;
    display: flex;
    align-items: center;
    margin-bottom: 10px;
    // border-radius: 4px;
    > span {
      flex: 1;
      font-size: 16px;
    }
  }
  > .tenant.select {
    color: #fff;
    background-color: #2878ec;
  }
  .sms_from {
    width: 400px;
    margin: auto;

    .verify_code {
      cursor: pointer;
    }
    .isverify.verify_code {
      cursor: auto;
    }
  }
}
// #index {
//   display: flex;
//   flex-direction: column;
//   > .tenant > .el-radio-button {
//     cursor: pointer;
//     // margin: 4px;
//     width: 200px;
//     margin: auto;
//     margin-bottom: 10px;
//     // background-color: #ebebeb;

//     display: flex;
//     align-items: center;
//     .el-radio-button__inner {
//       border: 1px solid #dcdfe6;
//       border-radius: 4px;
//     }
//     > span {
//       flex: 1;
//       font-size: 18px;
//     }
//     > img {
//       transform: rotate(180deg);
//     }
//   }
// }
</style>


// WEBPACK FOOTER //
// src/view/index/index.vue